import { Controller } from "@hotwired/stimulus"

// Browsers can't mark a rich-text editor required (its value sits in a hidden
// field), so an empty answer only came back from the server after Save
// (independent QA). On submit, every hidden field marked
// data-required-editor-message that is still empty stops the submit and shows
// its message under the editor. Runs after variable-insert has copied the
// editors into their fields (that listens in the capture phase above the form).
export default class extends Controller {
  connect() {
    this.check = this.check.bind(this)
    this.element.addEventListener("submit", this.check)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.check)
  }

  check(event) {
    let first = null
    this.element.querySelectorAll("input[data-required-editor-message]").forEach((input) => {
      const zone = input.closest("[data-variable-insert-target='dropzone']") || input.parentElement
      const editor = zone.querySelector("lexxy-editor")
      // An editor that hasn't loaded holds the saved text in its field; trust that.
      const loaded = !editor || editor._variableInsertHydrated
      const empty = loaded && !this.hasText(input.value)
      this.toggleMessage(zone, empty ? input.dataset.requiredEditorMessage : null)
      if (empty && !first) first = editor || input
    })
    if (!first) return

    event.preventDefault()
    event.stopImmediatePropagation()
    first.scrollIntoView({ block: "center" })
    first.querySelector?.("[contenteditable]")?.focus()
  }

  hasText(html) {
    const div = document.createElement("div")
    div.innerHTML = html || ""
    return div.textContent.trim().length > 0 || div.querySelector("img, table, action-text-attachment") !== null
  }

  toggleMessage(zone, message) {
    let note = zone.querySelector(":scope > [data-required-editor-note]")
    if (!message) {
      note?.remove()
      return
    }
    if (!note) {
      note = document.createElement("p")
      note.dataset.requiredEditorNote = ""
      note.className = "mt-1 text-sm text-error-600 dark:text-error-400"
      zone.appendChild(note)
    }
    note.textContent = message
  }
}
